<template>
  <ul class="teacon-list">
    <slot></slot>
  </ul>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'teacon-list'
  })
</script>

<style>
.teacon-list {
  @apply pl-6.5 space-y-4 leading-releaxed;
}
</style>
